module.exports = [{"name":"Twitter","icon":"twitter","type":"social-media","url":"https://twitter.com"},{"name":"Instagram","icon":"instagram","type":"social-media","url":"https://www.instagram.com/manvir.kaur98/?hl=en"},{"name":"Linkedin","icon":"linkedin","type":"social-media","url":"https://www.linkedin.com/in/manvir-kaur-098706140/"},{"name":"Email","icon":"envelope","type":"email","url":"mailto:manvirkaur2018@gmail.com"},{"name":"Facebook","icon":"facebook","type":"social-media","url":"https://www.facebook.com/profile.php?id=100009935084330"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/contacts.json
// module id = 393
// module chunks = 35783957827783